import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TenentContextService } from './tenent-context.service';
import { takeUntil } from 'rxjs/operators';
import { TenantSessionService } from '../tenant-session.service';

@Injectable({
  providedIn: 'root'
})
export class TenentIdentifierInterceptor implements HttpInterceptor {
  constructor(
    private tenantService: TenentContextService,
    private tenantSession: TenantSessionService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const headers = this.tenantService.addTenantToHeaders(request.headers);

    request = request.clone({
      headers: headers
    });
    // Never allow a response started for the previous tenant/session to update
    // one of the application's long-lived singleton stores.
    return next.handle(request).pipe(takeUntil(this.tenantSession.invalidated$));
  }
}
